import { PaymentTransactionType } from '#app/__generated__/api.js';
import { BreakpointNames } from '#app/theme/breakpoints.js';
import { ExcludeRelayFutureAddedValue } from '#app/types/utils.js';
import { TransactionLogColumns, TransactionStatus } from './types.js';

export const TRANSACTION_LOG_DESKTOP_BP: BreakpointNames = 'lg';
export const TRANSACTION_LOG_PAGE_SIZE = 20;
export const TRANSACTION_LOG_COLUMN_LABELS: Record<
  TransactionLogColumns,
  string
> = {
  AMOUNT: 'Amount',
  BILL_NUMBER: 'Bill no.',
  DATE: 'Date',
  DESCRIPTION: 'Description',
  PAID_BY: 'Paid by',
  STATUS: 'Status',
  TYPE: 'Type',
};

export const TRANSACTION_LOG_PAYMENT_TRANSACTION_TYPE_LABELS: Record<
  ExcludeRelayFutureAddedValue<PaymentTransactionType>,
  string
> = {
  PAYMENT: 'Payment',
  REFUND: 'Refund',
};

export const TRANSACTION_LOG_POPOVER_OFFSET = {
  alignOffset: 0,
  sideOffset: 18,
} as const;

export const TRANSACTION_STATUS_LABELS: Record<TransactionStatus, string> = {
  FAILED: 'Failed',
  PROCESSING: 'Processing',
  SUCCESSFUL: 'Succeeded',
};
